import React from 'react';
import PropTypes from 'prop-types';
import Collapse from 'rc-collapse';
import CollapsePanel from 'rc-collapse/lib/Panel';
import KitUploadedFiles from '../KitUploadedFiles';
import {fileFolders} from '../../../../../common/constants/fileFolders';
import folderIcon from 'common/assets/folder-4A4A4A.svg';
import 'rc-collapse/assets/index.css';
import styles from './styles.module.scss';

const FoldersAccordion = ({
                            content = [],
                            onFileDelete,
                            shumaTypeID
                          }) => {
  const getFolders = (folder) => {
    const filteredFolderContent = content.filter(file => (
      file.folderID === folder.id
      || file.customFolderID === folder.id
      || (folder.id === 7 && !file.folderID && !file.customFolderID)
    ));

    return filteredFolderContent.length > 0
      ? (
        <CollapsePanel
          key={folder.id}
          header={
            <div className={styles.folderHeaderContent}>
              <img
                src={folderIcon}
                alt="folder"
                className={styles.folderHeaderIcon}
              />
              <span>{folder.label}</span>
            </div>
          }
          showArrow={false}
        >
          <KitUploadedFiles
            data={filteredFolderContent}
            onFileDelete={onFileDelete}
            shumaTypeID={shumaTypeID}
            customContainerClassnames={styles.uploadedFiles}
          />
        </CollapsePanel>
      )
      : null;
  };


  return (
    <Collapse className={styles.accordionContainer}>
      {fileFolders.map(getFolders)}
    </Collapse>
  );
};

FoldersAccordion.propTypes = {
  accordion: PropTypes.bool,
  content: PropTypes.array,
  onFileDelete: PropTypes.func,
  shumaTypeID: PropTypes.number,
  thumbnails: PropTypes.array,
};

export default FoldersAccordion;
